// extracted by mini-css-extract-plugin
export default {"container":"EmailSummaryInfo_container__JkiUU","infoText":"EmailSummaryInfo_infoText__PoSRT","infoValue":"EmailSummaryInfo_infoValue__iLIfY"};